import apiClient from "../../../libs/axios";
import echo from "@/libs/echo";

export const state = {
    conversations: [],
    currentConversation: null,
    messages: {
        data: [],
        pagination: {
            current_page: 1,
            last_page: 1,
            per_page: 15,
            total: 0
        }
    },
    loading: false,
    error: null
}

export const mutations = {
    SET_CONVERSATIONS(state, conversations) {
        state.conversations = conversations.data
    },
    SET_CURRENT_CONVERSATION(state, conversation) {
        state.currentConversation = conversation
    },
    SET_MESSAGES(state, payload) {
        state.messages.data = payload.data
        state.messages.pagination = {
            current_page: payload.current_page,
            last_page: payload.last_page,
            per_page: payload.per_page,
            total: payload.total
        }
    },
    ADD_MESSAGE(state, message) {
        state.messages.push(message)
    },
    SET_LOADING(state, isLoading) {
        state.loading = isLoading
    },
    SET_ERROR(state, error) {
        state.error = error
    },
    RESET_MESSAGES(state) {
        state.messages = {
            data: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 15,
                total: 0
            }
        }
    },
    APPEND_MESSAGES(state, payload) {
        // Ensure both are arrays before spreading
        const currentMessages = Array.isArray(state.messages.data) ? state.messages.data : []
        const newMessages = Array.isArray(payload.data) ? payload.data : []

        state.messages.data = [...newMessages, ...currentMessages]

        state.messages.pagination = {
            current_page: payload.current_page,
            last_page: payload.last_page,
            per_page: payload.per_page,
            total: payload.total
        }
    },
    // Add PREPEND_MESSAGE mutation
    PREPEND_MESSAGE(state, message) {
        state.messages.data.unshift(message)
        state.messages.pagination.total++
    }
}

export const actions = {
    async fetchConversations({ commit }) {
        try {
            commit('app/loadingStart', null, {root: true});
            const response = await apiClient.get('/api/v1/admin/conversations', {
                params: {
                    include: 'user1,user2',
                    'filter[user1.role]': 'vendor',
                    'filter[user2.role]': 'customer'
                }
            })
            commit('SET_CONVERSATIONS', response.data.result)
        } catch (error) {
            commit('SET_ERROR', error.response?.data?.message || 'Error fetching conversations')
        } finally {
            commit('app/loadingFinish', null, {root: true});
        }
    },

    async fetchMessages({ commit, state }, conversationId) {
        try {
            // Determine correct page to load
            const shouldLoadInitialPage = state.messages.data.length === 0
            const nextPage = shouldLoadInitialPage
                ? 1
                : state.messages.pagination.current_page + 1

            commit('app/loadingStart', null, {root: true});
            const response = await apiClient.get(`/api/v1/conversations/${conversationId}/messages`, {
                params: {
                    page: nextPage
                }
            })

            const responseData = response.data.result?.data || []
            const paginationMeta = response.data || {
                current_page: 1,
                last_page: 1,
                per_page: 15,
                total: 0
            }

            // For initial load, replace messages
            if (shouldLoadInitialPage) {
                commit('SET_MESSAGES', {
                    data: response.data.result.data,
                    current_page: response.data.current_page,
                    last_page: response.data.last_page,
                    per_page: response.data.per_page,
                    total: response.data.total
                })
            }
            // For subsequent pages, append messages
            else {
                console.log(response.data.result.data);
                commit('APPEND_MESSAGES', {
                    data: responseData,
                    ...paginationMeta
                })
                // commit('APPEND_MESSAGES', {
                //     data: response.data.result.data,
                //     current_page: response.data.current_page,
                //     last_page: response.data.last_page,
                //     per_page: response.data.per_page,
                //     total: response.data.total
                // })
            }
        } catch (error) {
            commit('SET_ERROR', error.response?.data?.message || 'Error fetching messages')
            console.log(error);
        } finally {
            commit('app/loadingFinish', null, {root: true});
        }
    },

    async selectConversation({ commit, dispatch }, conversation) {
        commit('SET_CURRENT_CONVERSATION', conversation)
        commit('RESET_MESSAGES')
        await dispatch('fetchMessages', conversation.id)
        dispatch('listenForNewMessages', conversation.id)
    },

    listenForNewMessages({ commit, state }, conversationId) {
        echo.private(`conversation.${conversationId}`)
            .listen('MessageSent', (data) => {
                // Verify message belongs to current conversation
                if (data.message.conversation_id !== state.currentConversation?.id) return

                if (!state.messages.data.some(msg => msg.id === data.message.id)) {
                    commit('PREPEND_MESSAGE', data.message)
                    this.scrollToBottom('users-chat')
                }
            })
    }
}

export const getters = {
    formattedConversations: (state) => {
        return state.conversations.map(conv => ({
            id: conv.id,
            name: `${conv.participants.user1.name} ↔ ${conv.participants.user2.name}`,
            time: new Date(conv.updated_at).toLocaleDateString(),
            participants: {
                user1: conv.participants.user1,
                user2: conv.participants.user2
            }
        }))
        // return state.conversations.map(conv => console.log(conv))
    },
    hasMoreMessages: (state) => {
        return state.messages.pagination.current_page < state.messages.pagination.last_page
    }
}